(function () {
    'use strict';

    angular.module('swif.openbase')
        .service('swifOpenbaseUtilsService', swifOpenbaseUtilsService);

    function swifOpenbaseUtilsService() {
        'ngInject';
        var service = {};

        service.insertItemInArray = function (array, index, item) {
            array.splice(index, 0, item);
        };

        service.selectOneFormatNameChoice = function (choice) {
            if (choice && choice._type === 'equipment' && choice.equipment_reference !== 0) {
                return `ref - ${choice.equipment_reference} | ${choice.complete_name || choice.name}`;
            } else {
                return null
            }
        }

        return service;
    }
})();
